
import { Vue, Component } from 'vue-property-decorator'
import type { UserSsoOutDto, UserSso } from '@/api/swagger'

@Component({
  name: 'UserCompareInfoModal',
})
export default class UserCompareInfoModal extends Vue {
  private visible = false
  private columns = [
    {
      title: '字段',
      dataIndex: 'title',
      width: '20%',
    },
    {
      title: '当前账户信息',
      dataIndex: 'before',
      width: '40%',
    },
    {
      title: '最新账户信息',
      scopedSlots: { customRender: 'after' },
      width: '40%',
    },
  ]
  private originalData: UserSso | null = null
  private newData: UserSso | null = null
  private userType = ''

  private get dataSource() {
    switch (this.userType) {
      case '1':
        return [
          { title: '真实姓名', before: this.originalData?.realName || '', after: this.newData?.realName || '' },
          { title: '身份证号', before: this.originalData?.idCard || '', after: this.newData?.idCard || '' },
        ]
      case '2':
        return [
          {
            title: '区统一认证平台唯一标识',
            before: this.originalData?.userIdCode || '',
            after: this.newData?.userIdCode || '',
          },
          { title: '登录账户', before: this.originalData?.userName || '', after: this.newData?.userName || '' },
          { title: '真实姓名', before: this.originalData?.realName || '', after: this.newData?.realName || '' },
          { title: '身份证号', before: this.originalData?.idCard || '', after: this.newData?.idCard || '' },
          {
            title: '企业名称',
            before: this.originalData?.enterpriseName || '',
            after: this.newData?.enterpriseName || '',
          },
          {
            title: '企业信用代码',
            before: this.originalData?.uscc || '',
            after: this.newData?.uscc || '',
          },
          {
            title: '法人代表',
            before: this.originalData?.legalRepresentative || '',
            after: this.newData?.legalRepresentative || '',
          },
          {
            title: '法人电话',
            before: this.originalData?.legalMobile || '',
            after: this.newData?.legalMobile || '',
          },
        ]
      default:
        return []
    }
  }

  public show(data?: UserSsoOutDto) {
    this.userType = data?.userType || ''
    this.originalData = data?.sourceData || null
    this.newData = data?.newData || null
    this.visible = true
  }

  private confirm() {
    this.$emit('ok')
    this.visible = false
  }
}
